import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';

const NewNumbersLoading = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => {
      setIsVisible(true);
    });
  }, []);

  return (
    <div className={`skeleton select-option-button-container skeleton-smooth-loader ${isVisible ? 'visible' : ''}`}>
      <div className='border'></div>
      <div className='skeleton-title-container'>
        <div className={`skeleton-title skeleton-animation skeleton-main-title ${isMobile ? 'right' : ''}`}></div>
      </div>
      {Array.from({length: 5}, (_, index) => (
        <div key={index} className={`select-option-button skeleton-loader ${index === 4 ? 'last-child' : ''}`}>
          <div className='d-flex align-items-center'>
            <div className='select-option-radio-button'>
              <div className='skeleton-radio skeleton-animation'></div>
            </div>
            <div className='select-option-button-text'>
              <div className='skeleton-text skeleton-title skeleton-animation'></div>
            </div>
          </div>
        </div>
      ))}
      <div className='skeleton-bottom-container'>
        <div className='skeleton-button skeleton-animation'></div>
        <div className='skeleton-text skeleton-animation'></div>
        <div className='skeleton-subtext skeleton-animation'></div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  changePhoneNumber: state.changePhoneNumber,
});

export default connect(mapStateToProps)(NewNumbersLoading);
